import { render } from "./Bet.vue?vue&type=template&id=a43750e8&scoped=true"
import script from "./Bet.vue?vue&type=script&lang=js"
export * from "./Bet.vue?vue&type=script&lang=js"

import "./Bet.vue?vue&type=style&index=0&id=a43750e8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a43750e8"

export default script